import { useEffect } from 'react';

/*
 * The goal of this hook is to hide some parts of the main rails view when we pass the first step of the stepper.
 * Here we get from the dom some specific nodes and add or remove a specific class that will hide or show them.
 */
export const useShowIntro = (show = true) => {
  useEffect(() => {
    const introHeader = document.querySelector('#intro');
    const scrollSpy = document.querySelector('.tabs-with-anchor');
    const bulletPoints = document.querySelector('.pro-subscription-intro__text-block');

    if (show && introHeader) {
      introHeader.classList.remove('pro-subscription-intro__header--hide-in-mobile');
      if (bulletPoints) {
        // We never want to show the bullet points in mobile view (only the intro title)
        bulletPoints.classList.add('pro-subscription-intro__text-block--hide-in-mobile');
      }
    } else if (introHeader) {
      introHeader.classList.add('pro-subscription-intro__header--hide-in-mobile');
    }

    if (scrollSpy) scrollSpy.classList.add('tabs-with-anchor--hide-in-mobile');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
